import React from 'react';
import Styles from './styles.module.scss'

interface ICompletedElementProps {
    title: string;
}

function CompleteElement({
    title
}: ICompletedElementProps) {
    return <p className={Styles.SelectedOptionName}>- {title}</p>;
}

export default CompleteElement;